import React from 'react';
import './ModernLayout.css';

const ModernLayout = ({ 
  children,
  leftPanel,
  showTwoPanel = false 
}) => {
  return (
    <div className="modern-layout">
      {/* Main Content Area - Sidebar is handled by App.js */}
      <div className="main-content-area">
        {showTwoPanel ? (
          <div className="two-panel-layout">
            {/* Left Panel - Configuration */}
            <div className="left-panel">
              {leftPanel}
            </div>
            
            {/* Right Panel - Main Content */}
            <div className="right-panel">
              {children}
            </div>
          </div>
        ) : (
          <div className="single-panel-layout">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default ModernLayout;
